import { ProfessionIcon } from './profession-icon';

export const IconFitness = () => (
  <ProfessionIcon bg="#FCE4EC">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"
        stroke="#E91E63"
        strokeWidth="1.8"
      />
    </svg>
  </ProfessionIcon>
);
